import React, {useMemo} from 'react';
import {useTable, usePagination, useFilters} from 'react-table';
import {Table} from 'semantic-ui-react';
import {Filter, DefaultColumnFilter} from '../common/TableFilters';
import {columnsInvoiceTable} from '../../constants';
import {getRowValue, flatInputData} from '../../utils';
import TablePaginator from '../common/TablePaginator';

const WarrantyInvoiceTable = ({dataTable}) => {
  const flatData = flatInputData(dataTable);
  const data = useMemo(() => flatData, [dataTable]);
  const columns = useMemo(() => columnsInvoiceTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
    },
    useFilters,
    usePagination
  );

  return (
    <>
      <div className='table-container'>
        <Table className='interactive' striped {...getTableProps()}>
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign='center'
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => {
              if (data.length) {
                return (
                  <Table.Row key='filters' id='filters'>
                    {headerGroup.headers.map((column, index) => (
                      <Table.HeaderCell
                        key={`filter-${index}`}
                        textAlign='center'
                      >
                        <Filter column={column} />
                      </Table.HeaderCell>
                    ))}
                  </Table.Row>
                );
              }
              return null;
            })}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign='center'>
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i} {...row.getRowProps(getRowValue(row))}>
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell textAlign='center' {...cell.getCellProps()}>
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePaginator
        data={data}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default WarrantyInvoiceTable;
